export default "__VITE_ASSET__cba0e869__"